import { compose } from 'recompose'
import { withLocalization } from 'hocs/localization'
import SelectedPlan from './SelectedPlan'

export default compose(
  withLocalization('profile.progress.create'),
)(SelectedPlan)
